(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.factory('TranslationAsyncLoader', ['$http', '$q', TranslationAsyncLoaderFn]);

    // function custom loads the translations by $http -> $request does not work here
    function TranslationAsyncLoaderFn($http, $q) {
        return function (options) {
            // make deferred ref
            var deferred = $q.defer();

            // load the required translations by lang-key
            $http({
                method: 'GET',
                url: '/api/translations/' + options.key,
                headers: {
                    Authorization: undefined
                }
            }).then(function success(result) {
                // on success save the translations
                deferred.resolve(result.data);
            }, function error(response) {
                // return without data
                return deferred.reject(options.key);
            });

            // return
            return deferred.promise;
        };
    }
})();